import React, { useState } from 'react';
import ROUTE_NAME from '../../routes/RouteName';
import Icon from '../../assets/icons/Icon';
import { useNavigate } from 'react-router';

const Logout = () => {
    const navigate = useNavigate();

    const doLogout = () => {
        navigate(ROUTE_NAME.LOGOUT);
    };

    return (
        <button
            className="btn__logout"
            type="button"
            onClick={doLogout}
            title="Logout"
            data-cy="logout__btn"
        >
            <p>
                <Icon icon="Logout" inline width="20" />
            </p>
        </button>
    );
};

export default Logout;
